import { useCallback } from "react";
import { Dropdown } from "react-bootstrap";
import "./SidebarNavItem.css";

export default function SidebarNavItem({ item, onSelect, isDropdown = false }) {
  // useCallback to memoize the icon rendering function to avoid unnecessary re-renders
  const renderIcon = useCallback(
    (IconComponent) =>
      IconComponent ? (
        <IconComponent width={16} height={16} className="bi pe-none me-2" />
      ) : null,
    []
  );

  if (isDropdown) {
    return (
      <Dropdown.Toggle
        className="nav-link btn btn-link text-start w-100 link-body-emphasis d-flex align-items-center no-caret"
        style={{
          border: "none",
          background: "none",
          padding: "0.5rem 1rem",
          marginBottom: "5px",
          borderRadius: "0.375rem",
        }}
      >
        {renderIcon(item.icon)} {/* Render the icon */}
        {item.label} {/* Display the label */}
      </Dropdown.Toggle>
    );
  }

  return (
    <li className="nav-item" style={{ marginBottom: "5px" }}>
      <button
        type="button"
        className={`nav-link btn btn-link text-start w-100 link-body-emphasis`}
        onClick={onSelect} // Trigger the onSelect callback when the item is clicked
        style={{
          border: "none",
          background: "none",
          padding: "0.5rem 1rem",
          marginBottom: "5px",
          borderRadius: "0.375rem",
        }}
        aria-label={`Navigate to ${item.label}`} // Accessibility label for screen readers
      >
        {renderIcon(item.icon)} {/* Render the icon */}
        {item.label} {/* Display the label */}
      </button>
    </li>
  );
}
